import React from 'react'
import shield from "../../../../assets/img/admin/res/shield-search.svg";
import Button from "../../../shared/Button"
import fileDownload from 'js-file-download'

const AdminResidencesShow = ({inforesidencedetail}) => {
  return (
    <div className='mt-[40px]'>
      <Button  varient="outlined" onClick={()=>fileDownload(inforesidencedetail.residence_document," مجوز  گردشکری" )} fullwidth className="flex items-center gap-[8px] justify-center">
 
          <img src={shield}/>
          <p>مشاهده مجوز  گردشکری</p>

      </Button>
      <Button varient="primary" onClick={()=>fileDownload(inforesidencedetail.owner_certificate,"   سند مالکیت" )} fullwidth className="mt-[16px]">
      مشاهده سند مالکیت
      </Button>
    </div>
  )
}

export default AdminResidencesShow